
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightLanternOnColourOn as ObiLightLanternOnColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-lantern-on-colour-on.js';
 
 
 

 
 export const ObiLightLanternOnColourOn = createComponent({
   react: React,
   tagName: 'obi-light-lantern-on-colour-on',
   elementClass: ObiLightLanternOnColourOnElement,
   events: {
     
   }
  });
 
 